import React, { Fragment, useState } from "react";

import styles from "./KCardImagePagination.module.css";

const KCardImagePagination = function (props) {
  const [index, setIndex] = useState(0);
  const imagesNumber = props.imageSearch.length;

  const handleClick = function (e) {
    if (e.target.closest("button").id === "left") {
      paginate(-1);
      return;
    }
    paginate(1);
  };

  const paginate = function (direction) {
    if (index + direction >= imagesNumber) {
      setIndex(0);
      props.onImageChange(props.imageSearch[0]);
      return;
    }
    if (index + direction < 0) {
      setIndex(imagesNumber - 1);
      props.onImageChange(props.imageSearch[imagesNumber - 1]);
      return;
    }
    setIndex((prev) => prev + direction);
    props.onImageChange(props.imageSearch[index + direction]);
  };

  return (
    <Fragment>
      <img
        id="img"
        src={
          props.img !== "" ? `${props.img}` : require("../assets/logo-512.png")
        }
        alt=""
        className={styles.img}
      />
      {imagesNumber !== 0 && (
        <Fragment>
          <button
            id="left"
            className={styles.leftBtn}
            onClick={handleClick}
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={styles.chevron}
              viewBox="0 0 24 24"
              strokeWidth={1}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            id="right"
            className={styles.rightBtn}
            onClick={handleClick}
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={styles.chevron}
              viewBox="0 0 24 24"
              strokeWidth={1}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </Fragment>
      )}
    </Fragment>
  );
};

export default KCardImagePagination;
